<template>
  <div class="database-config">
    <div
      class="item"
      v-for="(item, index) in serverData"
      :key="index"
    >
      <div class="item-hd">
        {{ item.namePath }}
      </div>
      <div class="item-bd">
        <img
          v-for="(list, listIndex) in item.children"
          :key="listIndex"
          :src="list.data"
          :alt="list.name"
          @click="selectServer(item, list)"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectDatabase',
  props: {
    serverData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    selectServer(item, list) {
      this.$emit('selectServer', {
        kind: item.name,
        kindId: item.id,
        parentCode: item.code,
        type: list.name,
        typeId: list.id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.database-config {
  .item {
    padding: 0 12px 5px;
    border-bottom: 1px solid #e6e6e6;
    &-hd {
      position: relative;
      padding: 15px 0 5px 33px;
      &::before {
        position: absolute;
        left: 20px;
        top: 24px;
        content: "";
        width: 4px;
        height: 4px;
        background: #3273ff;
      }
    }
    &-bd {
      display: flex;
      img {
        width: 249px;
        height: 139px;
        object-fit: contain;
        cursor: pointer;
      }
    }
  }
}
</style>
